import { Form, Input, message, Select } from "antd";
import { BaseModal } from "./base.modal";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { mobiles } from "data/stats";
import { useBaseQuery } from "hooks/query.hook";
import { apiRoutes } from "api/data/routes";
export const MobileMethodModal = ({ onClose }: any) => {
  const { t } = useTranslation("balance");
  const [form] = Form.useForm();

  const [status, setStatus] = useState<any>("OPEN");

  const { error, isLoading, post, data } = useBaseQuery(
    `${apiRoutes.ACCOUNT_WITHDRAWAL_METHOD}`
  );
  const onSubmit = async (values: any) => {
      const payload = {
        method: "MobileMoney",
        currency: "XAF",
        ...values,
      };
      await post(payload);
  };

  useEffect(() => {
    if (error) {
      message.error(error || t("somethingWentWrong"));
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      message.success(t("withdrawalMethodSuccess"));
      onClose && onClose(true);
      setStatus('CLOSE');
    }
  }, [data]);


  return (
    <BaseModal
      title={t("createTitle")}
      subTitle={t("createSecondSubtitle")}
      confirmLoading={isLoading}
      onOk={() => form.submit()}
      status={status}
      okTitle={t("saveMethod")}
    >
      <Form
        className="paylink-form"
        name="signup-form"
        form={form}
        requiredMark={false}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form.Item
          name="provider"
          label={t("methodTypes.mobile.fields.operator")}
          rules={[{ required: true, message: "" }]}
        >
          <Select size="large" 
             options={mobiles}
          />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label={t("methodTypes.mobile.fields.phone")}
          rules={[{ required: true, message: "" }]}
        >
          <Input size="large" type="number" />
        </Form.Item>
      </Form>
    </BaseModal>
  );
};
